"use client";

import * as React from "react";
import * as Popover from "@radix-ui/react-popover";
import { Drawer } from "vaul";
import { AppLauncherContext } from "../providers/app-launcher-provider";
import { useMediaQuery } from "../../../hooks/use-media-query";
import { resolveEnvironment } from "../../../lib/environment";
import type { Environment, Theme } from "../../../types";
import "../styles/theme.css";
import "../styles/base.css";
import "../styles/keyframes.css";
import "../styles/component.css";
import "../styles/utilities.css";

export interface AppLauncherProps {
  env?: Environment;
  theme?: Theme;
  mobileBreakpoint?: number;
  domain?: string;
  children: React.ReactNode;
}

export function AppLauncher({
  env,
  theme = "dark",
  mobileBreakpoint = 768,
  domain,
  children,
}: AppLauncherProps) {
  const isMobile = useMediaQuery(`(max-width: ${mobileBreakpoint}px)`);
  const [open, setOpen] = React.useState(false);
  const close = React.useCallback(() => setOpen(false), []);
  const resolvedEnv = resolveEnvironment(env);

  const contextValue = React.useMemo(
    () => ({ env: resolvedEnv, theme, isMobile, open, domain, close }),
    [resolvedEnv, theme, isMobile, open, domain, close],
  );

  return (
    <AppLauncherContext.Provider value={contextValue}>
      {isMobile ? (
        <Drawer.Root
          key="drawer"
          direction="right"
          open={open}
          onOpenChange={setOpen}
          noBodyStyles
        >
          {children}
        </Drawer.Root>
      ) : (
        <Popover.Root key="popover" open={open} onOpenChange={setOpen}>
          {children}
        </Popover.Root>
      )}
    </AppLauncherContext.Provider>
  );
}
